// ---------------------------------------------------------------------------------------------------------------------
// Bootstrap
import 'bootstrap/js/src/base-component';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/modal';

// ---------------------------------------------------------------------------------------------------------------------
// Helper
import './helpers/fire-event';
import './helpers/get-css-property';

// ---------------------------------------------------------------------------------------------------------------------
// Components
import './components/scroll-lock';
import './components/scroll-offset';
import './components/switch-button';
import './components/navigation';
import './components/pagination-anchor';

// ---------------------------------------------------------------------------------------------------------------------
// Modules
import './modules/datamints-accordion';
import './modules/ke_search';
import './modules/tabs';
import './modules/service-finder';
import './modules/textslider';
import './modules/mainslider';
import './modules/technologyslider';
import './modules/form';
import './modules/timeline';
import './modules/lightbox';

// ---------------------------------------------------------------------------------------------------------------------
// Boot
import './bootstrap/page-header';
import './bootstrap/off-canvas';
import './bootstrap/scroll-lock';
import './bootstrap/main-navigation';
import './bootstrap/service-navigation';
import './bootstrap/news';
import './bootstrap/events';
